import styled from '@emotion/styled';
import { bodyB } from '@teamsparta/stack-font';

import { DESKTOP } from '@/styles/themes';

export const Wrapper = styled.button`
  display: flex;
  min-width: 70px;
  padding: 13px 14px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 999px;
  width: 100%;
  ${bodyB}
  background: gray;
  color: #fff;

  ${DESKTOP} {
    background: gray;
    color: #fff;
  }
`;
